import { useQuery } from 'react-query'

import { QueryKeys } from '../../../../../../../enums/queryKeys'
import { fetchEInvoiceAddressSchemeTypeList } from '../query-api'

export const useFetchEInvoiceAddressSchemeTypeList = () => {
  const { data, isLoading } = useQuery([QueryKeys.EInvoicingAddressSchemeTypeList], () =>
    fetchEInvoiceAddressSchemeTypeList(),
  )

  return {
    eInvoiceAddressSchemeTypeList: data?.data,
    isLoading,
  }
}
